import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { SdThemeComponent } from '@seb/web-design-system/core';

import { BaseFormErrorTranslateService } from '../forms/form-common-error/base-form-error-translate.service';
import { ErrorTranslateService } from '../forms/error-translate-service';
import { DeviceService } from '../../_services/device.service';
import { GetElementUtils } from '../../utils/getElement.utils';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLinkComponent } from '../links/link/link.component';
import { SdListComponent } from '../lists/list/list.component';
import { ILink } from '../../_interfaces/link.interface';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { ThemesEnum } from '../../_enums/themes.enum';

@Component({
  selector: 'sd-copyright',
  templateUrl: './copyright.component.html',
  standalone: true,
  imports: [
    SdLinkComponent,
    SdIconComponent,
    SdListComponent,
    TranslateModule,
    TitleCasePipe
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdCopyrightComponent extends SdThemeComponent implements OnInit {
  @Input()
  logoLink: ILink;

  @Input()
  links: ILink[];

  @Input()
  themesConfig: ThemesEnum.light | ThemesEnum.dark = ThemesEnum.light;

  @Input()
  changeCountryLink: string;

  @Input()
  changeCountryTitle: string;

  @Input()
  class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.themesConfig ? 'is-theme-' + this.themesConfig : '',
      this.class
    ]
      .filter(Boolean)
      .join(' ');
  }

  iconSize = IconSizeEnum;
  getElementUtils = GetElementUtils;
  themesEnum = ThemesEnum;
  isDevice$: boolean;
  subscriptions = new Subscription();

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
    super();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      })
    );
  }
}
